var arrayWithHoles = require("./arrayWithHoles");

var iterableToArray = require("./iterableToArray");

var nonIterableRest = require("./nonIterableRest");

function _toArray(arr) {
  return arrayWithHoles(arr) || iterableToArray(arr) || nonIterableRest();
}

module.exports = _toArray;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/toArray.js
// module id = 881
// module chunks = 0